import { gql } from '@apollo/client';

export default gql`
  query GetSignedUrl($fileType: String!, $contentType: String!) {
    signedUrlPayload(fileType: $fileType, contentType: $contentType)
      @rest(
        type: "SignedUrlRequest"
        path: "aws/signed-url/{args.fileType}?contentType={args.contentType}"
      ) {
      path
      signedRequest
      url
      awsFileName
    }
  }
`;
